export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_LOGIN_LOADING_STATUS = 'SET_LOGIN_LOADING_STATUS';
export const SET_CURRENT_USER_ATTRIBUTES = 'SET_CURRENT_USER_ATTRIBUTES';
